// extracted by mini-css-extract-plugin
var _1 = "pYa_7xTosW";
var _2 = "ihFvsaahc3";
var _3 = "lovYFOjxjg";
export { _1 as "bookPreview", _2 as "coverImage", _3 as "details" }
